import React from 'react';

export default function MailerLiteReport({ result }) {
  if (!result) return null;
  const problems = result.details?.filter(item => item.status !== 'exported') || [];
  return (
    <div className="space-y-2 text-xs">
      {result.total_selected != null && <p>
        {result.total_selected} ausgewählt · {result.dry_run ? `${result.valid_emails} exportierbar` : `${result.exported ?? ((result.added || 0) + (result.updated || 0))} übertragen`}
        {' · '}{result.skipped || 0} übersprungen · {result.failed || 0} fehlgeschlagen
      </p>}
      {(problems.length > 0 || result.errors?.length > 0) && (
        <details>
          <summary className="cursor-pointer font-medium">Gründe und Fehler anzeigen ({problems.length || result.errors.length})</summary>
          <ul className="mt-2 max-h-52 overflow-y-auto space-y-2 break-words">
            {problems.length ? problems.map((item, index) => (
              <li key={`${item.contact_id}-${index}`}>
                <span className="font-medium">{item.name}{item.email ? ` (${item.email})` : ''}</span>
                <p className={item.status === 'failed' ? 'text-destructive' : 'text-muted-foreground'}>{item.reason}</p>
              </li>
            )) : result.errors.map((error, index) => <li key={index} className="text-destructive">{error}</li>)}
          </ul>
        </details>
      )}
    </div>
  );
}
